import React, { Component } from 'react';
import { Col, Collapse, Row, Timeline, Typography } from 'antd';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { history } from '../../utils/history';
import { getAuditTrailAction } from '../../actions/ActivityAction';
import { getDateTimeDisplayText } from '../../utils/dateUtils';

const { Panel } = Collapse;
const { Text } = Typography;

const getHref = record => {
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <a
      onClick={() => {
        history.push('/updateUser/' + record.userId);
      }}
    >
      {record.username}
    </a>
  );
};

function getIconType(activity) {
  if (!activity) return null;
  if (activity.action === 'create') return '{<PlusCircleOutlined />}';
  if (activity.action === 'update') return '{<ToolOutlined />}';
  // if (activity.action === 'update') return '{<EditOutlined /}>';
  return null;
}

function getColorType(activity) {
  if (!activity) return null;
  if (activity.action === 'create') return 'green';
  if (activity.action === 'update') return 'blue';
  return null;
}

const capitalize = s => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};

class AuditTrail extends Component {
  panelCallback = val => {
    
    const {
      getAuditTrailAction: getAuditTrailAction1,
      objectId,
      objectType,
    } = this.props;
    if (val.length > 0) {
      getAuditTrailAction1({
        objectId,
        objectType,
      });
    }
    
  };

  render() {
    const { auditTrailLoading, auditTrailData, t } = this.props; 
    return (
      <Row>
        <Col>
          <Collapse
            // defaultActiveKey={['0']}
            onChange={this.panelCallback}
            // bordered={false}
          >
            <Panel header={t('changeHistory.changeHistory')} key="1">
              {auditTrailData &&
                auditTrailData.length === 0 &&
                t('changeHistory.noHistoryFound')}
              <Timeline pending={auditTrailLoading}>
                {auditTrailData &&
                  auditTrailData.map(data => (
                    <Timeline.Item
                      key={data.id}
                      color={getColorType(data)}
                      icon={getIconType(data)}
                    >
                      <div style={{ marginLeft: 8 }}>
                        <Text strong>
                          {data.action === 'create'
                            ? t('changeHistory.created')
                            : data.action === 'update'
                            ? t('changeHistory.updated')
                            : capitalize(data.action + 'd')}
                          </Text>{' '}
                          {t('changeHistory.by')} {getHref(data)} {t('changeHistory.at')}{' '}
                        <Text code>
                          {getDateTimeDisplayText(data.timestamp)}
                        </Text>
                      </div>
                    </Timeline.Item>
                  ))}
              </Timeline>
            </Panel>
          </Collapse>
        </Col>
      </Row>
    );
  }
}

AuditTrail.propTypes = {
  objectId: PropTypes.object,
  objectType: PropTypes.object,
  auditTrailData: PropTypes.array,
  auditTrailLoading: PropTypes.bool,
  getAuditTrailAction: PropTypes.func,
  t: PropTypes.func,
};

function mapStateToProps({ activityReducer }) {
  const { auditTrailData, auditTrailLoading } = activityReducer;
  return { auditTrailData, auditTrailLoading };
}

export default connect(mapStateToProps, {
  getAuditTrailAction,
})(withTranslation()(AuditTrail));
